"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PieDePA_gina() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark py-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          {}
          <div className="text-sm text-foreground-dark/80">
            &copy; {new Date().getFullYear()} Guillermo Bogao. Todos los derechos reservados.
          </div>

          {}
          <nav className="flex flex-wrap gap-4 text-sm">
            <Link to="/HomePage" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:left-0 hover:after:w-full">Inicio</Link>
            <Link to="/CoachingSessionsPage" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:left-0 hover:after:w-full">
              Sesiones de coaching
            </Link>
            <Link to="/AboutMePage" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:left-0 hover:after:w-full">
              Sobre mí
            </Link>
            <Link to="/ContactReserveSessionPage" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:left-0 hover:after:w-full">Contacto</Link>
          </nav>
        </div>
        <div className="mt-6 text-xs text-center text-foreground-dark/60">
  <Link to="/aviso-legal" className="hover:text-accent transition-colors">
    Aviso Legal
  </Link>{" "}
  |{" "}
  <Link to="/politica-privacidad" className="hover:text-accent transition-colors">
    Política de Privacidad
  </Link>{" "}
  |{" "}
  <Link to="/politica-cookies" className="hover:text-accent transition-colors">
    Cookies
  </Link>
</div>

        {}
        <div className="flex gap-4 justify-center md:justify-end mt-6">
          <Link to="#" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-medium)]" aria-label="Facebook">
            <Facebook className="size-5" />
          </Link>
          <Link to="#" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-medium)]" aria-label="Instagram">
            <Instagram className="size-5" />
          </Link>
          <Link to="#" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-medium)]" aria-label="LinkedIn">
            <Linkedin className="size-5" />
          </Link>
          <Link to="#" className="text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-medium)]" aria-label="Twitter">
            <Twitter className="size-5" />
          </Link>
        </div>
      </div>
    </footer>;
}